import { render } from "./statsThree.vue?vue&type=template&id=8bef85aa"
import script from "./statsThree.vue?vue&type=script&lang=js"
export * from "./statsThree.vue?vue&type=script&lang=js"

import "./statsThree.vue?vue&type=style&index=0&id=8bef85aa&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__